/** @type {import("vuex/types/index.d.ts").Module} */
export const ui = {
    namespaced: true,

    state: {
        window: {
            innerWidth: 0,
            innerHeight: 0,
            scrollY: 0,
        },
    },

    mutations: {
        setWindow(state, window) {
            state.window = window;
        },
    },

    actions: {
        init({ commit, state }) {
            window.addEventListener("resize", eventListner_resize.bind({ commit, state }));
            window.addEventListener("scroll", eventListner_scroll.bind({ commit, state }));
        },
        undo() {
            window.removeEventListener("resize", eventListner_resize);
            window.removeEventListener("scroll", eventListner_scroll);
        },
        exec({ commit, state }) {
            eventListner_resize.bind({ commit, state })();
            eventListner_scroll.bind({ commit, state })();
        },
    },
};

/** @this {import("vuex/types/index.d.ts").Store} */
function eventListner_resize() {
    this.commit("setWindow", {
        ...this.state.window,
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
    });
}

/** @this {import("vuex/types/index.d.ts").Store} */
function eventListner_scroll() {
    this.commit("setWindow", {
        ...this.state.window,
        scrollY: window.scrollY,
    });
}

export default ui;
